import React, { useEffect, useState } from "react";
import { fetchRatings, setRating } from "@/lib/api";
import { useAuth, startGoogleLogin } from "@/lib/auth";
import { Star } from "lucide-react";
import { toast } from "sonner";

export default function RatingWidget({ titleId }) {
  const { user } = useAuth() || {};
  const [data, setData] = useState({ average: null, count: 0, my_score: null });
  const [hover, setHover] = useState(0);

  const load = () => fetchRatings(titleId).then(setData).catch(() => {});
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [titleId, user?.user_id]);

  const submit = async (score) => {
    if (!user) { startGoogleLogin(); return; }
    try {
      await setRating(titleId, score);
      toast.success(`Rated ${score}/10`);
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    }
  };

  const current = hover || data.my_score || 0;

  return (
    <div className="border border-white/10 rounded-md bg-obsidian-surface/60 p-4" data-testid="rating-widget">
      <div className="flex items-center justify-between mb-2">
        <div className="text-[11px] uppercase tracking-[0.22em] text-amber font-heading">Your rating</div>
        <div className="text-xs text-zinc-500 font-heading">
          {data.average !== null ? (
            <span data-testid="rating-average">
              <span className="text-amber font-display text-lg">{data.average.toFixed(1)}</span>
              <span className="ml-1">/ 10 · {data.count} {data.count === 1 ? "vote" : "votes"}</span>
            </span>
          ) : (
            <span>No ratings yet</span>
          )}
        </div>
      </div>
      <div className="flex gap-0.5" onMouseLeave={() => setHover(0)} data-testid="rating-stars">
        {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => (
          <button
            key={n}
            onMouseEnter={() => setHover(n)}
            onClick={() => submit(n)}
            aria-label={`Rate ${n} out of 10`}
            data-testid={`rating-star-${n}`}
            className="p-0.5 transition"
          >
            <Star className={`h-5 w-5 transition ${n <= current ? "text-amber fill-amber" : "text-zinc-700"}`} />
          </button>
        ))}
      </div>
      {data.my_score && (
        <div className="text-xs text-zinc-500 mt-1.5 font-heading">
          You rated: <span className="text-amber">{data.my_score}/10</span>
        </div>
      )}
    </div>
  );
}
